import React from 'react';
import styled from 'styled-components';
import { primaryColor, secondaryColor, greyDark, blue } from '~theme';
import { Spinner } from '~ui-kit';

const getBgColor = props => {
  if (props.disabled) return greyDark;
  if (props.bgColor) return props.bgColor;
  if (props.secondary) return secondaryColor;
  if (props.cancel) return greyDark;
  return primaryColor;
};

const ButtonWrapper = styled.button`
  position: relative;
  padding: ${props => props.padding || '9px 10px'};
  outline: none;
  text-align: center;
  color: ${props => props.color || '#fff'};
  width: ${props => props.w || 'unset'};
  min-width: ${props => props.minWidth || 'unset'};
  height: ${props => props.h || 'unset'};
  border: ${props => props.border || 'none'};
  border-radius: ${props => props.borderRadius || '4px'};
  white-space: ${props => props.whiteSpace || 'nowrap'};
  background-color: ${props => getBgColor(props)};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: ${props => props.fontSize || '14px'};
  * {
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  }

  transition: all 0.15s ease-in-out;
`;

const ButtonContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;

  font-weight: 700;
  font-size: 16px;
`;

const Button = React.forwardRef(({ children, ...rest }, ref) => {
  if (rest.secondary) {
    return (
      <SecondaryButton ref={ref} type="button" {...rest}>
        {rest.$loading && (
          <SpinnerContainer>
            <Spinner size="16px" color={rest.color || blue} />
          </SpinnerContainer>
        )}
        {children}
      </SecondaryButton>
    );
  }

  return (
    <ButtonWrapper ref={ref} type="button" {...rest}>
      {rest.$loading && (
        <SpinnerContainer>
          <Spinner size="16px" color={rest.color || '#fff'} />
        </SpinnerContainer>
      )}
      <ButtonContent>{children}</ButtonContent>
    </ButtonWrapper>
  );
});

const SecondaryButton = styled.button`
  position: relative;
  padding: 8px 56px;

  font-weight: 700;
  font-size: 16px;

  color: ${blue};
  background-color: transparent;

  border: 2px solid ${blue};
  border-radius: 4px;
`;

const SpinnerContainer = styled.div`
  position: absolute;
  right: 50px;
  bottom: 2px;
`;

export default Button;
